import React from "react";
import moment from "moment";
import { toast, } from 'react-toastify';
import ReactTable from "react-table";
import { NavLink } from "react-router-dom";
import { Tooltip, } from '@material-ui/core';
import CustomDialog from "../../components/CustomDialog/Dialog.jsx"
import withStyles from "@material-ui/core/styles/withStyles";
import { Assignment, Close, } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import "../../assets/css/order.css"
import { fetchData } from '../../utils/handleApi'
import { styles } from './styles'
class OrderTables extends React.Component {
  state = {
    loading: false,
    arrOrders: [],
    showDialogForDelete: false
  };
  
  componentDidMount() {
    const { vendorId, lenderId } = this.props.match.params;
    this.setState({ loading: true });
    fetchData('order/all', 'post', {
      lender_id: this.props.match.params.lenderId
    })
    .then(data => {
      if(data.err){
        this.setState({ loading: false })
        return toast.error('Some error happened!')
      }
      let tempOrders = data.map(order => {
        return {
          id: order.id,
          order_no: order.order_no,
          bo_business_name: order.borrower.business_name || "N/A",
          bo_name: order.borrower.name || "N/A",
          order_date: moment(order.order_date).format('MM/DD/YYYY'),
          order_due_date: moment(order.due_date).format('MM/DD/YYYY'),
          completed_date: order.completed_date ? moment(order.completed_date).format('MM/DD/YYYY') : "N/A",
          product: (order.search_products_type && order.search_products_type.name) || "N/A",
          address: `${order.location.street_address} ${order.location.city} ${
            order.location.state
          } ${order.location.zip}`,
          attachments: (
            <div style={{ textAlign: "center" }}>
              <NavLink
                to={`/admin/vendor/${vendorId}/lender/${lenderId}/order/${order.id}/attachments`} 
                style={{textDecorationLine: 'underline', color:"#04ab23"}}
              >
                View
              </NavLink>
            </div>
          ),
          actions: (
            <div className="actions-right">
              <NavLink 
                to={{ 
                  pathname: `/admin/vendor/${vendorId}/lender/${lenderId}/order/${order.id}/edit`, 
                  state: this.props.location.state 
                }}>
                <Button
                  justIcon
                  round
                  simple
                  color="success"
                  className="Edit"
                >
                  <Tooltip title="Edit">
                    <EditIcon />
                  </Tooltip>
                </Button>{" "}
              </NavLink>
              <Button
                justIcon
                round
                simple
                onClick={() => {
                  this.setState({
                    showDialogForDelete: true,
                    idToDelete: order.id
                  });
                }}
                color="danger"
                className="remove"
              >
                <Tooltip title="Delete">
                  <Close />
                </Tooltip>
              </Button>{" "}
            </div>
          )
        };
      });
      this.setState({
        arrOrders: tempOrders,
        loading: false
      });
    })
  }

  handleYes = () => {
    const { idToDelete, arrOrders } = this.state;
    fetchData('order/delete', 'post', {
      order_id: idToDelete
    })
    .then(data => {
      if(data.err){
        return this.setState({ showDialogForDelete: false }, () => {
          toast.error('Some error happened!')
        })
      }
      let orders = arrOrders;
      orders = orders.filter(order => order.id !== idToDelete);
      this.setState({
        arrOrders: orders,
        showDialogForDelete: false
      }, () => {
        toast.success('Order deleted successfully!')
      });
    })
  }
  
  render() {
    const { classes } = this.props;
    const { loading, arrOrders, showDialogForDelete } = this.state;
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader  icon>
              <CardIcon color="success">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Orders</h4>
              <NavLink to={{ 
                pathname: `/admin/vendor/${this.props.match.params.vendorId}/lender/${this.props.match.params.lenderId}/order-add/`, 
                state: this.props.location.state }}>
                <Button 
                  variant="contained"
                  style={{
                    float: 'right',
                    margin: '5px',
                    backgroundColor: "rgb(4, 171, 35)"
                  }}
                >
                  Add Order
                </Button>
              </NavLink>
              <NavLink to={`/admin/vendors/${this.props.match.params.vendorId}/lenders`}>
                <Button 
                  variant="contained"
                  style={{
                    float: 'right',
                    margin: '5px',
                    backgroundColor: "rgb(4, 171, 35)"
                  }}
                >
                  Back
                </Button>
              </NavLink>
           
            </CardHeader>
            <CardBody>
              <ReactTable
                loading={loading}
                NoDataComponent={() => !loading && <p style={{textAlign: "center"}}>No Orders available</p>}
                data={arrOrders}
                filterable
                columns={[
                  {
                    Header: "Order No.",
                    accessor: "order_no"
                  },
                  {
                    Header: "Borrower Business Name",
                    accessor: "bo_business_name"
                  },
                  {
                    Header: "Borrower Name",
                    accessor: "bo_name"
                  },
                  {
                    Header: "Order Date",
                    accessor: "order_date"
                  },
                  {
                    Header: "Order Due Date",
                    accessor: "order_due_date"
                  },
                  {
                    Header: "Order Completed Date",
                    accessor: "completed_date"
                  },
                  {
                    Header: "Product",
                    accessor: "product"
                  },
                  {
                    Header: "Address",
                    accessor: "address"
                  },
                  {
                    Header: "Attachments/ Order Updates",
                    accessor: "attachments",
                    headerStyle: { textAlign: 'center' },
                    filterable: false,
                    width: 180
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
                defaultPageSize={10}
                minRows={0}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight custom-order"
              />
            </CardBody>
          </Card>
        </GridItem>
        <CustomDialog
          deleteWho="Order"
          showDialogForDelete={showDialogForDelete}
          closeDialog={() => this.setState({ showDialogForDelete: false })}
          handleYes={this.handleYes}
        />
      </GridContainer>
    );
  }
}

export default withStyles(styles)(OrderTables);
